/** Texts for messages emitted by the domain (analysis, strategies, data). */
export const domain = {
  en: {
    // data validation
    "val.invalidPrice": "Bar with missing or non-positive price removed",
    "val.invalidOhlc": "Bar with inconsistent OHLC removed",
    "val.duplicates": "{n} duplicate bar(s) merged",
    "val.unsorted": "Candles are not strictly increasing in time",
    "val.gap": "{missing} expected bar(s) missing before {day}",
    "val.badTick": "Suspicious {r} spike on {day} that immediately reversed — possible bad tick",
    "val.extremeMove": "Extreme {r} move on {day}",
    "val.stale": "Latest bar closed {hours}h ago — data may be stale",
    "val.tooFew": "Only {n} bars available; at least {min} needed",
    "val.refreshFailed": "Latest refresh failed: {error}",

    // market analysis
  },

  de: {
    "val.invalidPrice": "Periode mit fehlendem oder nicht positivem Kurs entfernt",
    "val.invalidOhlc": "Periode mit inkonsistenten OHLC-Werten entfernt",
    "val.duplicates": "{n} doppelte Periode(n) zusammengeführt",
    "val.unsorted": "Kerzen sind zeitlich nicht streng aufsteigend",
    "val.gap": "{missing} erwartete Periode(n) fehlen vor dem {day}",
    "val.badTick": "Verdächtiger Ausschlag von {r} am {day}, sofort wieder umgekehrt — möglicher Fehlkurs",
    "val.extremeMove": "Extreme Bewegung von {r} am {day}",
    "val.stale": "Letzte Periode wurde vor {hours} Std. geschlossen — Daten könnten veraltet sein",
    "val.tooFew": "Nur {n} Perioden verfügbar; mindestens {min} nötig",
    "val.refreshFailed": "Letzte Aktualisierung fehlgeschlagen: {error}",
  },
} as const;
